import React from "react";
import { v4 } from "uuid";

import {
  IgButton,
  IgCopyTextTypography,
  IgDivider,
  IgPaper,
  IgTypography,
} from "@intelligems/ig-theme";
import { BaseIntegrationDto } from "@intelligems/ig-types";
import { Grid, Skeleton } from "@mui/material";

import { useGetIntegrations } from "../../../../api/integrations/get-integrations";
import { usePutApiIntegration } from "../../../../api/integrations/put-api-integration";
import { GreenCheckIcon } from "../../../../images/Icons/GreenCheckIcon";

interface AmpedIntegrationProps {
  ampedIntegration?: BaseIntegrationDto;
}

export const AmpedIntegration = ({
  ampedIntegration,
}: AmpedIntegrationProps) => {
  const integrations = useGetIntegrations();
  const putApiIntegration = usePutApiIntegration();

  const onEnableClick = (action: "new" | "refresh" | "delete") => {
    putApiIntegration.mutate({
      body: {
        app: "Amped",
        keys: [
          {
            id: ampedIntegration?.id ? ampedIntegration.id : v4(),
            action,
            description: "Amped Integration",
            name: "Amped",
          },
        ],
      },
      pathParams: undefined,
      queryParams: undefined,
    });
  };

  return (
    <IgPaper sx={{ border: "none" }}>
      <Grid
        container
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item>
          <Grid container alignItems={"center"}>
            {ampedIntegration?.enabled ? (
              <Grid item sx={{ marginRight: "15px", marginTop: "6px" }}>
                <GreenCheckIcon />
              </Grid>
            ) : null}
            <Grid item>
              <IgTypography
                sx={{
                  lineHeight: "26px",
                  letterSpacing: "0.5px",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                Amped
              </IgTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <IgButton
            variant={"contained"}
            loading={putApiIntegration.isPending}
            onClick={() => onEnableClick(ampedIntegration ? "refresh" : "new")}
          >
            {ampedIntegration ? "Regenerate Token" : "Enable"}
          </IgButton>
        </Grid>
      </Grid>
      {ampedIntegration && ampedIntegration?.enabled ? (
        <Grid container item direction={"column"}>
          <Grid item>
            <IgDivider spacing={"s"} />
          </Grid>

          <Grid container item alignItems={"center"} columnSpacing={2}>
            <Grid item>
              <IgTypography sx={{ fontWeight: 600 }}>
                Access Token:{"  "}
              </IgTypography>
            </Grid>
            <Grid item sx={{ width: "388px" }}>
              {putApiIntegration.isPending || integrations.isFetching ? (
                <Skeleton />
              ) : (
                <IgCopyTextTypography
                  text={ampedIntegration.apis[0].accessToken}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </IgPaper>
  );
};
